<template>
  <div>
    <AccountInfoComponent v-if="isRegistered"></AccountInfoComponent>

    <v-card v-else max-width="940" class="mx-auto my-2">
      <v-card-text>
        <v-tabs background-color="#743063" fixed-tabs dark>
          <v-tab>سجل الدخول</v-tab>
          <v-tab>متبرع جديد</v-tab>
          <v-tab-item><LogInComponent></LogInComponent> </v-tab-item>
          <v-tab-item> <SignUpComponent></SignUpComponent> </v-tab-item>
        </v-tabs>
      </v-card-text>
    </v-card>
    <div v-if="!isRegistered" class="d-flex justify-center ma-2">
      <p>
        هل نسيت كلمة المرور؟
        <v-btn color="primary" @click="showForgotPasswordDialog = true" text>
          اضغط هنا
        </v-btn>
      </p>
    </div>

    <v-dialog v-model="showForgotPasswordDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline"> نسيت كلمة المرور </v-card-title>
        <v-card-text>
          <p>قم باخال الايميل للحصول على رابط تحديد كلمة مرور جديدة</p>

          <v-text-field
            v-model="email"
            hint="الرجاء كتابة الايميل الذي سجلت به"
            label="الايميل"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="showForgotPasswordDialog = false">
            الغاء
          </v-btn>
          <v-btn
            :loading="isSending"
            color="green darken-1"
            text
            @click="forgotPassword"
          >
            ارسال
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar top color="#019891" v-model="snackbar" timeout="5000">
      تم ارسال رسالة إلى ايميلك تحتوي رابط تغيير كلمة المرور

      <template v-slot:action="{ attrs }">
        <v-btn color="white" icon v-bind="attrs" @click="snackbar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import LogInComponent from "@/components/LogInComponent";
import SignUpComponent from "@/components/SignUpComponent";
import AccountInfoComponent from "@/components/AccountInfoComponent";

export default {
  name: "AccountComponent",

  //********************** */
  components: {
    LogInComponent,
    SignUpComponent,
    AccountInfoComponent,
  },

  //********************** */
  data: () => ({
    isLoggingOut: false,
    isLoading: false,
    showError: false,
    showForgotPasswordDialog: false,
    email: "",
    isSending: false,
    snackbar: false, 
  }),

  //********************** */
  computed: {
    ...mapGetters("Account", {
      isRegistered: "isRegistered",
    }),
  },

  //********************** */
  methods: {
    logOut: async function () {
      this.isLoggingOut = true;
      try {
        this.$store.dispatch("Account/logOut");
        await this.$store.dispatch("Account/signUpAnonymous");
      } catch (error) {
        this.showError = true;
        setTimeout(() => (this.showError = false), 3000);
        alert(error);
      }
      this.isLoggingOut = false;
    },

    forgotPassword: async function () {
      this.isSending = true;
      try {
        await this.$store.dispatch("Account/forgotPassword", this.email);
        this.showForgotPasswordDialog = false;
        this.snackbar = true;
      } catch (error) {
        //this.showError = true;
        //setTimeout(() => (this.showError = false), 3000);
        alert(error);
      }
      this.isSending = false;
    },
  },

  //*********************** */
  async mounted() {},
};
</script>

<style>
</style>